<template>
  <div>
    <vx-card class="mb-4">
      <div class="flex flex-col gap-4">
        <validation-observer ref="validator" #default="{valid}">
          <b-form @submit.prevent="createOrUpdate">
            <div class="vx-row">
              <div class="vx-col w-full">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('newsletter.title')"
                  rules="required"
                  class="flex-grow"
                  slim>
                  <b-form-group
                    id="newsletter_title"
                    :label="$t('newsletter.title')"
                    label-for="newsletter_title">
                    <b-form-input
                      id="newsletter_title"
                      v-model="model.title"
                      :state="errors.length > 0 ? false:null"
                      name="newsletter_title"
                      class="required"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <select-suggestion
                  column="company_name,trading_name,cnpj"
                  model="LegalEntity"
                  v-model="selectedLegalEntity"
                  :label="$t('legal_entities_unit')"
                  :appendClearOption="true"
                  placeholderText="Digite o nome ou cnpj da pessoa jurídica"
                  :itemTextFormat="legalEntityItemTextFormat"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full sm:w-1/2">
                <!-- group_news_id -->
                <validation-provider
                    #default="{ errors }"
                    :name="$t('group_news.group')"
                    rules="required"
                    class="flex-grow"
                    slim>
                    <div class="flex grid-cols-2">
                      <div class="w-10/12">
                        <select-suggestion
                          :key="groupNewsKey"
                          column="name"
                          model="GroupNews"
                          v-model="selectedGroupNews"
                          :label="$t('group_news.group')"
                          :appendClearOption="true"
                          placeholderText="Digite o nome do grupo"
                          class="required"
                          @clearSelection="clearSubgroupNews"
                          @selected-model="clearSubgroupNews"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </div>
                      <div class="w-2/12 flex justify-center" :class="enableSubgroupNews ? 'items-end' : 'items-center'">
                        <b-button v-tooltip.top="{content: 'Adicionar um novo grupo',delay: { show: 100, hide: 100 }}"
                          variant="outline-primary"
                          size="sm"
                          @click="showAddGroupModal">
                          <feather-icon icon="PlusIcon" />
                        </b-button>
                      </div>
                    </div>
                  </validation-provider>
              </div>
              <div class="vx-col w-full sm:w-1/2">
                <!-- subgroup_news_id -->
                <validation-provider
                    #default="{ errors }"
                    :name="$t('subgroup_news.subgroup')"
                    rules="required"
                    class="flex-grow"
                    slim>
                    <div class="flex grid-cols-2">
                      <div class="w-10/12">
                        <select-suggestion
                          :key="subgroupNewsKey"
                          column="name"
                          model="SubgroupNews"
                          v-model="selectedSubgroupNews"
                          :label="$t('subgroup_news.subgroup')"
                          :appendClearOption="true"
                          placeholderText="Digite o nome do subgrupo"
                          class="required"
                          :disabled="!enableSubgroupNews"
                          :extraParamsFilters="{group_news_id: selectedGroupNews ? selectedGroupNews.id : null}"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </div>
                      <div class="w-2/12 flex justify-center" :class="(selectedSubgroupNews && selectedSubgroupNews.id) ? 'items-end' : 'items-center'">
                        <b-button v-if="enableSubgroupNews"
                          v-tooltip.top="{content: 'Adicionar um novo subgrupo',delay: { show: 100, hide: 100 }}"
                          variant="outline-primary"
                          size="sm"
                          @click="showAddSubgroupModal">
                          <feather-icon icon="PlusIcon" />
                        </b-button>
                      </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <!-- -->
            <div class="vx-row pt-1">
              <div class="vx-col w-full">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('newsletter.link')"
                  rules="required"
                  class="flex-grow"
                  slim>
                  <b-form-group
                    id="newsletter_link"
                    :label="$t('newsletter.link')"
                    label-for="newsletter_link">
                    <b-form-input
                      id="newsletter_link"
                      v-model="model.link"
                      :state="errors.length > 0 ? false:null"
                      name="newsletter_link"
                      class="required"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                        <span class="align-left small w-full flex ml-1 text-break cursor-pointer pt-1 pb-2 gap-2"
                          v-clipboard:copy="exemploLink"
                          v-clipboard:success="() => {notifySuccess($vs, 'Cópia realizada com sucesso.')}"
                          v-clipboard:error="() => {notifyError($vs, 'Não foi possível realizar a cópia.')}"
                          v-tooltip.top="{content: 'Copiar link completo',delay: { show: 100, hide: 100 }}"
                          >
                          <feather-icon
                              icon="LinkIcon"
                              svgClasses="h-5 w-5 mb-1 stroke-current text-primary mr-1 align-midle"/>
                          {{exemploLink}}
                        </span>
                  </b-form-group>
                </validation-provider>
              </div>
            </div>
            <!-- -->
            <div class="vx-row">
              <div class="vx-col flex">
                <!-- -->
                <validation-provider
                  #default="{ errors }"
                  :name="$t('newsletter.status')"
                  rules="required"
                  class="flex-grow"
                  slim>
                  <b-form-group
                    :label="$t('newsletter.status')"
                    label-for="status">
                    <b-form-radio-group
                      id="status"
                      name="status"
                      v-model="model.status">
                      <b-form-radio value="DR">{{$t('newsletter.status_.DR')}}</b-form-radio>
                      <b-form-radio value="RE">{{$t('newsletter.status_.RE')}}</b-form-radio>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-radio-group>
                  </b-form-group>
                </validation-provider>
              </div>
              <div class="vx-col flex">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('newsletter.allows_comment')"
                  rules="required"
                  class="flex-grow"
                  slim>
                  <b-form-group
                    :label="$t('newsletter.allows_comment')"
                    label-for="allows_comment">
                    <b-form-checkbox
                      id="allows_comment"
                      name="allows_comment"
                      v-model="model.allows_comment"
                      switch class="mr-n2">
                    </b-form-checkbox>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>
              <div class="vx-col flex">
                <!-- -->
                <validation-provider
                  #default="{ errors }"
                  :name="$t('newsletter.allows_enjoy')"
                  rules="required"
                  class="flex-grow"
                  slim>
                  <b-form-group
                    :label="$t('newsletter.allows_enjoy')"
                    label-for="allows_enjoy">
                    <b-form-checkbox
                      id="allows_enjoy"
                      name="allows_enjoy"
                      v-model="model.allows_enjoy"
                      switch class="mr-n2">
                    </b-form-checkbox>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>
              <div class="vx-col flex">
                <!-- -->
                <validation-provider
                  #default="{ errors }"
                  :name="$t('newsletter.allows_signature')"
                  rules="required"
                  class="flex-grow"
                  slim>
                  <b-form-group
                    :label="$t('newsletter.allows_signature')"
                    label-for="allows_enjoy">
                    <b-form-checkbox
                      id="allows_signature"
                      name="allows_signature"
                      v-model="model.allows_signature"
                      switch class="mr-n2">
                    </b-form-checkbox>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <b-form-group
                  :label="$t('newsletter.content')"
                  label-for="content">
                  <complex-editor :editor_data.sync="model.content"/>
                </b-form-group>
              </div>
            </div>
          </b-form>
          <div class="w-full flex gap-2 justify-end">
              <b-button
                v-if="!isEdit()"
                variant="primary"
                :disabled="!valid"
                v-permission="'newsletters.create'"
                @click="createOrUpdate">
                {{ $t('action.save') }}
              </b-button>
              <b-button
                v-if="isEdit()"
                v-permission="'newsletters.edit'"
                @click="createOrUpdate"
                variant="primary"
                :disabled="!valid">
                {{ $t('action.save') }}
              </b-button>
            <b-button
              variant="outline-secondary"
              class="float-right"
              @click="goBack">
              <feather-icon
                icon="CornerUpLeftIcon"
                class="mr-50"/>
              <span class="align-middle">{{$t('back')}}</span>
            </b-button>
          </div>
        </validation-observer>
      </div>
    </vx-card>
    <b-modal
      ref="addSubgroupModal"
      title="Adicionar subgrupo"
      hide-footer
      centered>
      <b-form-input v-model="newSubgroupName" placeholder="Digite o nome do subgrupo" />
      <div class="w-full flex gap-2 justify-end pt-4">
        <b-button variant="primary" @click="addSubgroup">
          {{$t('action.save')}}
        </b-button>
        <b-button variant="outline-secondary" @click="closeAddSubgroupModal">
          {{$t('action.cancel')}}
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="addGroupModal"
      title="Adicionar grupo"
      hide-footer
      centered>
      <b-form-input v-model="newGroupName" placeholder="Digite o nome do grupo" />
      <div class="w-full flex gap-2 justify-end pt-4">
        <b-button variant="primary" @click="addGroup">
          {{$t('action.save')}}
        </b-button>
        <b-button variant="outline-secondary" @click="closeAddGroupModal">
          {{$t('action.cancel')}}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import standard from '@/services/standard'
import { v4 as uuidv4 } from 'uuid'
import { isAdmin } from '@/util/Util'
import {
  BRow,
  BCol,
  BCardText,
  BForm,
  BFormGroup,
  BFormRadioGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BFormCheckbox,
  BFormRadio,
  BButton,
  BIconClipboard,
  BFormInvalidFeedback,
  VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min, max } from '@validations'
import SelectSuggestion from '@/components/SelectSuggestion.vue'
import ComplexEditor from '@/components/ComplexEditor.vue'

import NewsletterService from '@/services/api/NewsletterService'
import SubgroupNewsService from '@/services/api/SubgroupNewsService'
import GroupNewsService from '@/services/api/GroupNewsService'

export default {
   directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormRadioGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormCheckbox,
    BFormRadio,
    BCardText,
    BFormInput,
    BButton,
    BIconClipboard,
    BFormInvalidFeedback,
    // validations
    ValidationProvider,
    ValidationObserver,
    // Custom
    SelectSuggestion,
    ComplexEditor,
  },
  props: {
    id: {
      default: null,
      type: Number
    }
  },

  data: () => ({
    subgroupNewsService: null,
    groupNewsService: null,
    service: null,
    model: {
      id: null,
      title : '',
      subgroup_news_id: null,
      link: '',
      status: 'DR',
      allows_comment: false,
      allows_enjoy: false,
      allows_signature: false,
      content: '',
      legal_entity_id: null,
    },
    selectedGroupNews: null,
    selectedSubgroupNews: null,
    selectedLegalEntity: null,
    //Validation
    required, min, max,
  }),
  computed: {
    validateForm() {
      return true//!this.isEmpty(this.model.title)
            //&& !this.isEmpty(_.get(this.model, 'link'))
            //&& !this.isEmpty(this.model.content)
    },
    exemploLink(){
      return `${this.protocolLocation()}/#/newsletters/pub/${_.kebabCase(this.model.link)}`
    },
    enableSubgroupNews(){
      return this.selectedGroupNews !== null && this.selectedGroupNews.id !== null
    },
    groupNewsKey(){
      return this.selectedGroupNews ? this.selectedGroupNews.id : null
    },
    subgroupNewsKey(){
      return this.selectedSubgroupNews ? this.selectedSubgroupNews.id : null
    }
  },
  watch: {

  },
  beforeMount() {
    this.service = NewsletterService.build(this.$vs)
    this.subgroupNewsService = SubgroupNewsService.build(this.$vs)
    this.groupNewsService = GroupNewsService.build(this.$vs)
  },
  mounted() {
    if (this.id) {
      this.loadData(this.id)
    }
    if(!this.isEdit()){
      if(!this.model.link){
        this.model.link = this._.kebabCase(uuidv4())
      }
    }
  },

  methods: {
    requiredClass(whichData) {
      return !this.isEmpty(whichData) ? 'w-full' : 'w-full required'
    },
    loadData(id) {
      this.$vs.loading()

      this.service.read(id).then(
        response => {
          this.model = response
          this.selectedGroupNews = response.subgroup.group
          this.selectedSubgroupNews = response.subgroup
          this.selectedLegalEntity = response.legal_entity
        },
        error => {
          this.$vs.loading.close()
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    createOrUpdate() {
      this.$vs.loading()

      const modelData = {
        id: this.id,
        title: this.model.title,
        subgroup_news_id: this.selectedSubgroupNews.id,
        status: this.model.status,
        allows_comment: this.model.allows_comment,
        allows_enjoy: this.model.allows_enjoy,
        allows_signature: this.model.allows_signature,
        link: this._.kebabCase(this.model.link),
        content: this.model.content,
        legal_entity_id: this.selectedLegalEntity ? this.selectedLegalEntity.id : null
      }

      this.service.createOrUpdate(modelData).then(
        data => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          if(!this.isEdit()){
            this.$router.push(`/newsletters/${data.id}/edit`)
          }
        },
        error => {
          this.showErrors(this.$validator, error)
        }
      ).finally(
        () => { this.$vs.loading.close() }
      )
    },
    goBack() {
      this.$router.push('/newsletters')
    },
    isAdmin() {
      return isAdmin()
    },
    isEdit() {
      return !_.isNil(this.id)
    },
    clearSubgroupNews(){
      console.log('clearSubgroupNews')
      this.selectedSubgroupNews = null
      // Força a reatividade do componente filho
      this.$nextTick(() => {
        // Garante que a mudança seja propagada para o componente filho
        this.$forceUpdate()
      })
    },
    showAddSubgroupModal() {
      if(!this.selectedGroupNews || !this.selectedGroupNews.id){
        this.notifyError(this.$vs, 'Selecione ou crie um grupo, antes de adicionar um subgrupo', 5000)
        return
      }
      this.$refs.addSubgroupModal.show()
      this.newSubgroupName = ''
    },
    addSubgroup() {
      if(!this.newSubgroupName){
        this.notifyError(this.$vs, 'Digite o nome do subgrupo', 5000)
        return
      }
      this.subgroupNewsService.create({
        name: this.newSubgroupName,
        group_news_id: this.selectedGroupNews.id
      }).then(response => {
        this.clearSubgroupNews()
        this.selectedSubgroupNews = response
        this.notifySuccess(this.$vs, 'Subgrupo adicionado com sucesso')
        this.$refs.addSubgroupModal.hide()
      }).catch(error => {
        console.log(error)
      })
    },
    closeAddSubgroupModal() {
      this.newSubgroupName = ''
      this.$refs.addSubgroupModal.hide()
    },
    showAddGroupModal() {
      this.$refs.addGroupModal.show()
      this.newGroupName = ''
    },
    addGroup() {
      if(!this.newGroupName){
        this.notifyError(this.$vs, 'Digite o nome do grupo', 5000)
        return
      }
      this.groupNewsService.create({
        name: this.newGroupName
      }).then(response => {
        this.selectedGroupNews = response
        this.clearSubgroupNews()
        this.selectedSubgroupNews = null
        this.notifySuccess(this.$vs, 'Grupo adicionado com sucesso')
        this.$refs.addGroupModal.hide()
      }).catch(error => {
        console.log(error)
      })
    },
    closeAddGroupModal() {
      this.newGroupName = ''
      this.$refs.addGroupModal.hide()
    },
    legalEntityItemTextFormat(model){
      if (this._.isEmpty(model)) return ''

      let string = `${model.company_name} - ${model.trading_name}`

      if (model.cnpj) {
        string = `${string} (${this.cnpjFormat(model.cnpj)})`
      }

      return string
    },
  }
}
</script>

<style>

</style>
